module.exports = __webpack_public_path__ + "static/media/sa.6e5f7f9a.jpg";